import { render, staticRenderFns } from "./CompanyStatusToggle.vue?vue&type=template&id=670de37d&scoped=true&"
import script from "./CompanyStatusToggle.vue?vue&type=script&lang=js&"
export * from "./CompanyStatusToggle.vue?vue&type=script&lang=js&"
import style0 from "./CompanyStatusToggle.vue?vue&type=style&index=0&id=670de37d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670de37d",
  null
  
)

export default component.exports